import React from 'react'
import PropTypes from 'prop-types'
import modules from './button.module.scss';
import StyledButton from '../StyledButton';
import withTheme from '../../hoc/withTheme';

const Button = (props = {}) => {
    const { className, variant, solid, outline, ...rest } = props
    return <StyledButton 
        className={`${modules.button} ${className}`.trim()}  
        $variant={variant} 
        $solid={solid} 
        $outline={outline} 
        {...rest} />
}

Button.defaultProps = {
    outline: false,
    className: '',
    variant: 'primary'
}

Button.propTypes= {
    variant: PropTypes.oneOf(['primary', 'secondary', 'background', 'action', 'text'])
}

export default withTheme(Button)